<template>
  <!-- The admin door: the console door's shape, visibly the OPERATOR's
       entrance (the amber line, and the badge where « Terrain » sits — both
       matching AdminLayout) — signing into admin. must never look like signing
       into the console. -->
  <div class="min-h-screen flex flex-col bg-background text-foreground font-sans antialiased">
    <div class="h-1 w-full bg-amber-500 dark:bg-amber-600 shrink-0" />
    <div class="flex-1 flex flex-col items-center px-4 pt-[9vh] pb-12">
      <router-link to="/login" class="mb-7 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
        <BrandMark stacked ground="page" :size="52">
          <Badge variant="secondary" class="uppercase tracking-wider">{{ t('admin.title') }}</Badge>
        </BrandMark>
      </router-link>

      <main class="w-full flex flex-col items-center">
        <router-view />
      </main>

      <LanguageLink class="mt-6" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BrandMark from '@/components/layout/BrandMark.vue'
import LanguageLink from '@/components/layout/LanguageLink.vue'
import { useI18n } from 'vue-i18n'
import { Badge } from '@/components/ui/badge'

const { t } = useI18n()
</script>
